/*
 *  Copyright (c) 2021.
 *  This file is part of the Compo B2B application.
 *  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>, Dmitri Puscas <degwelloa@gmail.com>
 *  For the full copyright and license information, please view the LICENSE
 *  file that was distributed with this source code.
 */

export interface SearchSettings {
  id?: number;

  stock: number;
  recommended: number;
  actionProduct: number;
  hasPrice: number;
  hasImage: number;

  codeField: number;
  codeFieldNgram: number;
  codesManufacturer: number;
  codesManufacturerNgram: number;
  manufacturerHeader: number;
  brandHeader: number;
  synonyms: number;
  header: number;
  headerNgram: number;
  headerKeyword: number;
  synonymsCatalog: number;
  synonymsCatalogNgram: number;
  synonymsManufacturer: number;
  synonymsManufacturerNgram: number;
  className: number;
  classSynonym: number;
  headerAuto: number;

  delimeterCodeField: number;
  delimeterCodeFieldKeywords: number;
  delimeterHeader: number;
  delimeterHeaderNgram: number;
  delimeterHeaderKeyword: number;
  delimeterHeaderWorldDelimeter: number;
  delimeterCodesManufacturer: number;
  delimeterCodesManufacturerKeyword: number;
  delimeterManufacturerHeader: number;
  delimeterSynonyms: number;
  delimeterSynonymsWorldDelimeter: number;
  delimeterSynonymsNgram: number;
  delimeterSynonymsCatalog: number;
  delimeterSynonymsCatalogNgram: number;
  delimeterSynonymsManufacturer: number;
  delimeterSynonymsManufacturerNgram: number;
  delimeterClassName: number;
  delimeterClassSynonym: number;
  delimeterHeaderAuto: number;

}
